import React, { useMemo } from 'react'
import { formatDate } from '~/utils/date'
import { mutualTheme } from '~/utils/theme'
import { makeStyles } from '@material-ui/styles'
import { Box, Typography } from '@material-ui/core'
import { ClockIcon, TimerIcon } from '~/assets/icons'
import { AccountAnalysisStatus } from '@mutual-services/account-types'

type BadgeType = 'error' | 'success' | 'info' | 'warning'

export type TimeContainerProps = {
  type: BadgeType,
  analysisDate: Date | null,
  status: AccountAnalysisStatus
}

const useStyles = makeStyles({
  itemContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: mutualTheme.spacing(4),
    color: mutualTheme.palette.common.white,
    [mutualTheme.breakpoints.down('md')]: {
      alignItems: 'flex-start'
    }
  },
  itemInnerContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: mutualTheme.spacing(1),
    marginLeft: mutualTheme.spacing(1),
    [mutualTheme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: mutualTheme.spacing(0)
    }
  },
  itemTitle: {
    fontWeight: 500
  },
  itemValue: {
    fontWeight: 800
  }
})

export const TimeContainer: React.FC<TimeContainerProps> = (props) => {
  const { type, analysisDate, status } = props
  const classes = useStyles()

  const timeItem = useMemo(() => {
    if (status === AccountAnalysisStatus.ANALYST_QUEUE ||
      status === AccountAnalysisStatus.WAITING_FOR_ANALYSIS ||
      status === AccountAnalysisStatus.UNDER_ANALYSIS) {
      return (
        <>
          <TimerIcon htmlColor={mutualTheme.palette.badgeBackgroundColor[type].light} />
          <Box className={classes.itemInnerContainer}>
            <Typography variant='airbnbBody1' className={classes.itemTitle}>Prazo estimado:</Typography>
            <Typography variant='airbnbBody1' className={classes.itemValue}>{status === AccountAnalysisStatus.ANALYST_QUEUE ? '1 dia útil' : '2 dias úteis'}</Typography>
          </Box>
        </>
      )
    }
    if (status === AccountAnalysisStatus.DENIED ||
      status === AccountAnalysisStatus.DENIED_POST_ANALYSIS) {
      return (
        <>
          <ClockIcon htmlColor={mutualTheme.palette.badgeBackgroundColor[type].light} />
          <Box className={classes.itemInnerContainer}>
            <Typography variant='airbnbBody1' className={classes.itemTitle}>Analisado em</Typography>
            <Typography variant='airbnbBody1' className={classes.itemValue}>{analysisDate ? formatDate(analysisDate) : '-'}</Typography>
          </Box>
        </>
      )
    }
  }, [status])

  return (
    <>
      {timeItem}
    </>
  )
}
